import type { Permission, UserType } from "@shared/contracts/permissions";
import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/lib/queryClient";

interface AuthUser {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  userType: UserType;
  status: "active" | "inactive" | "pending";
  assignedRoles: Array<{
    id: string;
    slug: string;
    name: string;
    audience: "internal" | "client" | "all";
    isSystem: boolean;
  }>;
  effectivePermissions: Permission[];
  twoFactorEnabled: boolean;
  profileImageUrl: string | null;
  clientId: string | null;
  hasPassword: boolean;
  partnerId: string | null;
  partnerName: string | null;
}

export function useAuth() {
  const {
    data: user,
    isLoading,
    error,
  } = useQuery<AuthUser | null>({
    queryKey: ["/api/auth/me"],
    queryFn: getQueryFn({ on401: "returnNull" }),
    retry: false,
  });

  return {
    user: user ?? null,
    isLoading,
    isAuthenticated: !!user,
    error,
  };
}
